export default __webpack_public_path__ + "static/media/VerticalDashedBorder.141c686e.svg";